<template>
  <detailTemplate :classCustom="'detail-docs'">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>
      <!--header-->
      <div class="header flex-row">
        <el-tag
          v-if="hcCaseCalendar.approveStatus === 'Chưa phê duyệt'"
          size="mini"
          class="priority lv2"
        >
          {{ hcCaseCalendar.approveStatus }}
        </el-tag>
        <el-tag
          v-if="hcCaseCalendar.approveStatus === 'Tạm phê duyệt'"
          size="mini"
          class="priority lv3"
        >
          {{ hcCaseCalendar.approveStatus }}
        </el-tag>
        <el-tag
          v-if="hcCaseCalendar.approveStatus === 'Đã ban hành'"
          size="mini"
          class="priority lv4"
        >
          {{ hcCaseCalendar.approveStatus }}
        </el-tag>
        <el-tag
          v-if="hcCaseCalendar.approveStatus === 'Hủy yêu cầu'"
          size="mini"
          class="priority lv1"
        >
          {{ hcCaseCalendar.approveStatus }}
        </el-tag>
        <el-tag
          v-if="hcCaseCalendar.approveStatus === 'Không phê duyệt'"
          size="mini"
          class="priority lv1"
        >
          {{ hcCaseCalendar.approveStatus }}
        </el-tag>
      </div>
      <!--content-->
      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div
            class="font-size__large font-weight__bold margin-bottom-10 margin-top-10"
            style="color: #007aff"
          >
            Yêu cầu đăng ký lịch tuần
          </div>
          <!--Don vi yeu cau-->
          <div class="margin-top-10">
            <span class="label-input">Cấp quy trình:</span>
            <span class="font-weight__bold">{{

              hcCaseCalendar.parentDeptName
            }}</span>
          </div>

          <!--Don vi yeu cau-->
          <div class="margin-top-10">
            <span class="label-input">Đơn vị yêu cầu:</span>
            <span class="font-weight__bold">{{

              hcCaseMaster.requestDeptName
            }}</span>
          </div>

          <!--Nguoi yeu cau & thoi gian yeu cau-->
          <div class="padding-bottom-10 flex-row has-border__bottom">
            <span class="label-input">Người yêu cầu:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">{{

                hcCaseMaster.requestUserFullname
              }}</span>
            </div>

            <span class="label-input margin-left-10">vào lúc:</span>
            <el-date-picker
              size="medium"
              class="input-none__border input-border__radius__0 padding-left-0 el-date-picker-bold"
              type="datetime"
              placeholder="dd/mm/yyyy"
              format="dd/MM/yyyy HH:mm"
              v-model="hcCaseMaster.createTime"
              :prefix-icon="' '"
              :readonly="true"
            >
            </el-date-picker>
          </div>

          <!--THÔNG TIN YÊU CẦU & THÔNG TIN PHÒNG HỌP-->
          <div class="form-info padding-right-10 padding-bottom-10">
            <el-form

              :model="hcCaseCalendar"
              :rules="rules"
              ref="form"
              label-position="left"
              label-width="150px"
            >

              <el-row :gutter="24">
                <el-col :span="24" v-if = "tenantCode === TENANT_CODE.VINATABA">
                  <!--tieu de-->
                  <el-form-item prop="meetingTitle" label="Nội dung">
                    <el-input
                      type="text"
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      size="medium"
                      :readonly="!update && !approve"
                      clearable
                      maxlength="200"
                      ref="title"
                      v-model="hcCaseCalendar.meetingTitle"
                    />
                  </el-form-item>
                </el-col>

                <el-col v-if="tenantCode !== TENANT_CODE.VINATABA" :span="24">
                  <el-form-item prop="meetingContent" label="Tiêu đề">
                    <el-input
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="textarea"
                      size="medium"
                      maxlength="200"
                      v-model="hcCaseCalendar.meetingTitle"
                      :readonly="!update && !approve"
                      ref="meetingContent"
                    />
                  </el-form-item>
                </el-col>


                <el-col v-if="tenantCode !== TENANT_CODE.VINATABA" :span="24">
                  <!--noi dung cong viec-->
                  <el-form-item prop="meetingContent" label="Nội dung">
                    <el-input
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="textarea"
                      size="medium"
                      maxlength="400"
                      :autosize="{ minRows: 3, maxRows: 5 }"
                      v-model="hcCaseCalendar.meetingContent"
                      :readonly="!update && !approve"
                      ref="meetingContent"
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <!--thoi gian bat dau-->
                  <el-form-item prop="startTime" label="Thời gian bắt đầu">
                    <el-date-picker
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      size="medium"
                      type="datetime"
                      format="dd/MM/yyyy HH:mm"
                      :prefix-icon="' '"
                      :readonly="!update && !approve"
                      v-model="hcCaseCalendar.startTime"
                    >

                    </el-date-picker>
                  </el-form-item>
                </el-col>


                <el-col :span="24">
                  <!--thoi gian ket thuc-->
                  <el-form-item prop="endTime" label="Thời gian kết thúc">
                    <el-date-picker
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      size="medium"
                      type="datetime"
                      format="dd/MM/yyyy HH:mm"
                      :prefix-icon="' '"
                      :readonly="!update && !approve"
                      v-model="hcCaseCalendar.endTime"
                    >

                    </el-date-picker>
                  </el-form-item>
                </el-col>


                <el-col :span="24">
                  <!--loại cuộc họp-->
                  <el-form-item prop="meetingType" label="Loại cuộc họp">
                    <el-select
                      clearable
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      v-model="hcCaseCalendar.meetingType"
                      filterable
                      placeholder="-"
                      size="medium"
                      @change="meetingTypeChanged"
                      :disabled="!update && !approve"
                    >

                      <el-option-group>
                        <el-option
                          v-for="item in meetingTypeOptions"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        ></el-option>
                      </el-option-group>
                      <el-option-group :label="'Họp trực tuyến'">
                        <el-option
                          v-for="item in meetingTypeOptions2"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </el-col>


                <!--phòng họp-->
                <el-col :span="24">
                  <el-form-item
                    prop="hcCfgMeetingRoomId"
                    v-if="
                      hcCaseCalendar.meetingType ===
                        MEETING_TYPE.ONLINE_MOBIMEETING_CODINH
                    "
                  >
                    <template #label>
                      <span>
                        Phòng họp:
                        <el-tooltip
                          content="Thêm mới phòng họp Mobimeeting cố định"
                          placement="top"
                          effect="dark"

                          v-if="
                            (update || approve) &&
                              hcCaseCalendar.meetingType ===
                                MEETING_TYPE.ONLINE_MOBIMEETING_CODINH
                          "
                        >
                          <i
                            class="fa fa-plus-circle color__cyan clickable"
                            @click="openAddNewMeetingRoomDialog"
                          ></i>
                        </el-tooltip>
                      </span>

                    </template>


                    <el-select
                      clearable
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      v-model="hcCaseCalendar.hcCfgMeetingRoomId"
                      filterable
                      placeholder="Phòng họp"
                      size="medium"
                      @change="hcCfgMeetingRoomIdChanged"
                      :disabled="!update && !approve"
                    >
                      <el-option
                        v-for="item in hcCfgMeetingRooms"
                        :key="item.id"
                        :label="item.roomName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <!--dia diem-->
                <el-col :span="24">
                  <el-form-item
                    v-if="
                      hcCaseCalendar.meetingType === MEETING_TYPE.OFFLINE ||
                        hcCaseCalendar.meetingType === MEETING_TYPE.ONLINE_OTHER
                    "
                    prop="meetingPlace"
                    label="Địa điểm"
                  >
                    <el-input
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="text"
                      size="medium"
                      :readonly="!update && !approve"
                      maxlength="200"
                      ref="meetingPlace"
                      placeholder="Địa điểm"
                      v-model="hcCaseCalendar.meetingPlace"
                      v-if="hcCaseCalendar.meetingType !== MEETING_TYPE.OFFLINE"
                    />

                    <el-autocomplete
                      v-else
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="text"
                      size="medium"
                      maxlengt="200"
                      v-model="hcCaseCalendar.meetingPlace"
                      :fetch-suggestions="querySearchHcCfgMeetingRoom"
                      @change="meetingPlaceChanged"
                      @select="handleSelectHcCfgMeetingRoom"
                      placeholder="Địa điểm"
                      :disabled="!update && !approve"
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <!--danh sach lanh dao-->
                  <el-form-item
                    class="custom-label__input width25"
                    label="Danh sách lãnh đạo"
                  >
                    <div class="width__100">
                      <div
                        v-if="update || approve"
                        :class="[

                          'content',
                          groups && groups.length ? '' : 'has-border__bottom'
                        ]"
                      >
                        <a class="select-link" @click="openSelectActorDialog">
                          - Chọn danh sách lãnh đạo -
                        </a>
                      </div>
                      <div
                        class="content width__100"
                        v-if="groups && groups.length"
                      >
                        <el-table
                          ref="multipleTable"
                          :data="groups"
                          size="medium"
                          :show-header="false"
                        >

                          <el-table-column
                            type="index"
                            width="50"
                          ></el-table-column>
                          <el-table-column
                            label="Đơn vị nhận văn bản"
                            show-overflow-tooltip
                          >

                            <template slot-scope="scope">
                              <div
                                class="flex-row flex__left"
                                v-if="scope.row.type === 'item'"
                              >
                                <div class="info">
                                  <span class="people__name">
                                    {{ scope.row.data.fullName }}
                                  </span>
                                  <span
                                    class="people__position margin-left-5"
                                    v-if="scope.row.data.userDeptRoleId"
                                  >
                                    ({{ scope.row.data.positionName }} -
                                    {{ scope.row.data.deptName }})
                                  </span>
                                </div>

                              </div>
                              <div class="flex-row flex__left" v-else>
                                <div class="avt"></div>
                                <div class="info">
                                  <p class="people__name">
                                    {{ getLabelForFilter(scope.row.filter) }}
                                  </p>
                                </div>

                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>

                <el-col v-if="tenantCode !== 'vinatabatrading.com.vn'" :span="24">
                  <!--Ban lanh dao-->
                  <el-form-item
                    class="custom-label__input width25"
                    label="Ban lãnh đạo"
                  >
                    <div class="width__100">
                      <div
                        v-if="update || approve"
                        :class="[

                          'content',
                          banLds && banLds.length ? '' : 'has-border__bottom'
                        ]"
                      >
                        <a class="select-link" @click="openSelectBanLanhDaoDialog">
                          - Chọn ban lãnh đạo -
                        </a>
                      </div>
                      <div
                        class="content width__100"
                        v-if="tenantCode !== 'vinatabatrading.com.vn' && banLds && banLds.length"
                      >
                        <el-table
                          ref="multipleTable"
                          :data="banLds"
                          size="medium"
                          :show-header="false"
                        >
                          <el-table-column
                            type="index"
                            width="50"
                          ></el-table-column>
                          <el-table-column
                            label="Đơn vị nhận văn bản"
                            show-overflow-tooltip
                          >
                            <template slot-scope="scope">
                              <div class="flex-row flex__left">
                                <div class="info">
                                  <span class="people__name">
                                    {{ scope.row.label }}
                                  </span>
                                </div>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="Đơn vị chủ trì">
                    <el-select
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      v-model="chairUnitSelectedIds"
                      multiple
                      filterable
                      placeholder="- Chọn đơn vị chủ trì -"
                      :disabled="!update && !approve"
                    >
                      <el-option
                        v-for="item in ListDonViChuTri"
                        :key="item.id"
                        :label="item.deptName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>


                <el-col :span="24">
                  <!--đơn vị phối hợp -->
                  <el-form-item label="Đơn vị phối hợp">
                    <el-select
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      v-model="cooperateSelectedIds"
                      multiple
                      filterable
                      placeholder="- Chọn đơn vị phối hợp -"
                      :disabled="!update && !approve"
                    >
                      <el-option
                        v-for="item in ListchairedUnit"
                        :key="item.id"
                        :label="item.deptName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="24" v-if="isVinataba">
                  <!--thành phần tham dự -->
                  <el-form-item label="Thành phần tham dự">
                    <el-select
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      v-model="participantsSelectedIds"
                      multiple
                      filterable
                      remote
                      placeholder="- Chọn thành phần tham dự -"
                      :remote-method="getSourceListTptd"
                      :loading="isTptdLoading"
                      :disabled="!update && !approve"
                    >
                      <el-option
                        v-for="item in sourceListTptd"
                        :key="item.id"
                        :label="buildUserDeptRoleViewLabel(item)"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <!-- Thành phần khác -->
                  <el-form-item label="Thành phần">
                    <el-input
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="textarea"
                      size="medium"
                      :readonly="!update && !approve"
                      maxlength="500"
                      show-word-limit
                      v-model="hcCaseCalendar.others"
                      :autosize="{ minRows: 3, maxRows: 5 }"
                    />
                  </el-form-item>
                </el-col>

                <el-col v-if="tenantCode !== TENANT_CODE.VINATABA" :span="24">
                  <!--thanh phan tham du-->
                  <el-form-item label="Ghi chú">
                    <el-input
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="textarea"
                      size="medium"
                      :readonly="!update && !approve"
                      maxlength="500"
                      show-word-limit
                      v-model="hcCaseCalendar.otherInvolved"
                      :autosize="{ minRows: 3, maxRows: 5 }"
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <!--file đính kèm-->
                  <el-form-item
                    v-if="
                      ((vbAttachments && vbAttachments.length) || isCanUpload) && tenantCode !== TENANT_CODE.VINATABA
                    "
                    label="File đính kèm"
                  >
                    <div class="jobInfoAttachment">
                      <div
                        v-for="vbAttachment in vbAttachments"
                        v-bind:key="vbAttachment.id"
                        class="file-uploaded input-none__border"
                      >
                        <div

                          class="file clickable flex-row flex__between padding-0"
                        >

                          <a
                            class="flex-row flex__left margin-left-10"
                            @click="downloadFile(vbAttachment)"
                          >

                            <file-type-image
                              :fileExtention="vbAttachment.fileExtention"
                            />
                            <el-tooltip
                              :content="vbAttachment.fileName"
                              placement="top"
                            >

                              <span class="" :title="vbAttachment.fileName">{{
                                vbAttachment.fileName
                              }}</span>
                            </el-tooltip>
                          </a>
                          <i
                            v-if="isCanUpload"
                            class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red"
                            @click="removeAttachment(vbAttachment)"
                          ></i>
                        </div>

                      </div>
                      <el-upload
                        v-if="isCanUpload"
                        class="upload-demo style-fullWidth inputLog"
                        drag
                        :action="uploadAttachmentURL"
                        size="medium"
                        :on-success="
                          response =>
                            onUploadSuccess(response).then(response =>
                              uploadAttachmentSuccess(response)
                            )
                        "
                        :data="uploadAttachmentAdditionalData"
                        :file-list="attachmentFiles"
                        :show-file-list="false"
                        :headers="uploadAttachmentHeaders"
                        :before-upload="
                          file =>
                            validateUploadFile(file, {
                              acceptFileTypes: ['*']
                            })
                        "
                        :on-error="onUploadError"
                        v-loading="isUploading"
                      >
                        <div class="el-upload__text mb-10">
                          <p class="margin-0 padding-0">Tải tệp đính kèm</p>
                          <i class="fas fa-cloud-upload color__silver"></i>
                        </div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <!--ghi chu-->
                  <el-form-item label="Lý do hủy">
                    <el-input
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="textarea"
                      size="medium"
                      maxlength="400"
                      v-model="hcCaseCalendar.note"
                      @blur="
                        hcCaseCalendar.note = (hcCaseCalendar.note || '').trim()
                      "
                      :autosize="{ minRows: 3, maxRows: 5 }"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <div
                class="group__info margin-top-10 margin-bottom-10"
                v-if="
                  hcCaseCalendar.meetingType === MEETING_TYPE.OFFLINE &&
                    !!hcCaseCalendar.hcCfgMeetingRoomId &&
                    (isRequester || update || approve)
                "
              >
                <div class="title font-size__medium">Chi tiết phòng họp</div>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-form-item label="Trạng thái">
                      <hc-case-calendar-phonghop-state
                        v-if="!!hcCasePhonghop"
                        :hcCaseMasterId="hcCasePhonghop.caseMasterId"
                      ></hc-case-calendar-phonghop-state>
                    </el-form-item>
                  </el-col>


                  <el-col :span="24">
                    <el-form-item label="Thành phần khác" prop="otherInvolved2">
                      <el-input

                        type="textarea"
                        v-model="hcCaseCalendar.otherInvolved2"
                        placeholder="Thành phần khác"
                        class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                        size="medium"

                        maxlength="2000"
                        show-word-limit
                        :autosize="{ minRows: 2, maxRows: 5 }"
                        :readonly="!update && !approve"
                      ></el-input>
                    </el-form-item>

                  </el-col>

                  <el-col :span="16">
                    <el-form-item label="Độ quan trọng" prop="criticalLevel">
                      <el-select
                        class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                        v-model="hcCaseCalendar.criticalLevel"
                        placeholder="Độ quan trọng"
                        size="medium"
                        filterable
                        clearable
                        :disabled="!update && !approve"
                      >
                        <el-option
                          v-for="item in criticalLevels"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="24">
                    <el-form-item label="Dịch vụ chuẩn bị" prop="services">
                      <el-checkbox-group
                        v-model="hcCaseCalendar.services"
                        class="width__100"
                        :disabled="!update && !approve"
                      >
                        <el-checkbox
                          v-for="item in serviceOptions"
                          :key="item.value"
                          :label="item.value"
                          >{{ item.name }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </div>
        </div>
      </VuePerfectScrollbar>
      <!--footer-->
      <div class="footer">
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              class="addDocs color__blue btn-none__border"
              size="medium"
              v-if="approve"
              @click="changeCalendarStatus()"
            >
              <i class="fas fa-arrow-circle-right font-size__small"></i
              >&nbsp;Tạm duyệt
            </el-button>

            <el-button
              class="addDocs color__blue btn-none__border"
              size="medium"
              v-if="approve"
              @click="approveRequest()"
            >
              <i class="fas fa-arrow-circle-right font-size__small"></i
              >&nbsp;Ban hành
            </el-button>

            <el-button
              class="addDocs color__red btn-none__border"
              size="medium"
              v-if="decline"
              @click="declineRequest()"
            >
              <i class="fas fa-times-circle font-size__small"></i>&nbsp;Từ chối
            </el-button>

            <el-button
              class="addDocs color__blue btn-none__border"
              size="medium"
              v-if="update"
              @click="beforeUpdateRequest"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>&nbsp;Cập nhật
            </el-button>

            <el-button
              class="addDocs color__red btn-none__border"
              size="medium"
              v-if="cancel || selfCancel"
              @click="cancelRequest()"
            >
              <i class="fas fa-times-circle font-size__small"></i>&nbsp;Hủy yêu
              cầu
            </el-button>

            <el-button
              class="addDocs color__blue btn-none__border"
              size="medium"
              @click="share()"
              v-if="isCanUpload && hcCaseCalendar.status === 'HOANTHANH'"
            >
              <i class="fas fa fa-share-alt font-size__small"></i>&nbsp;Chia sẻ
            </el-button>

            <el-button
              class="addDocs color__blue btn-none__border"
              size="medium"
              @click="joinRoom()"
              v-if="ableToJoinMeeting"
            >
              <i class="fas fa fa-sign-in font-size__small"></i>&nbsp;Vào họp
            </el-button>

            <el-button
              class="addDocs color__red btn-none__border"
              size="medium"
              v-if="isDisplayDeleteButton"
              @click="deleteRequest()"
            >
              <i class="fas fa-times-circle font-size__small"></i>&nbsp;Xóa
            </el-button>
          </div>
        </div>
      </div>
      <hc-case-calendar-sharing-dialog
        :isOpen="isOpenShareDialog"
        :hcCaseCalendarId="hcCaseCalendar.id"
        v-if="isEnableShareDialog"
        @dialogClosed="isEnableShareDialog = false"
        @closeDialog="isOpenShareDialog = false"
        @success="sharingSuccess"
      >
      </hc-case-calendar-sharing-dialog>

      <lichtuan-select-actors-dialog
        :deptId="hcCaseCalendarParentDeptId"
        :isOpen="isOpenSelectActorDialog"
        :selectedActors="leadersSelected"
        v-if="isEnableSelectActorDialog"
        @changed="afterSelectActors"
        @closed="isEnableSelectActorDialog = false"
        @closeDialog="isOpenSelectActorDialog = false"
      ></lichtuan-select-actors-dialog>

      <lichtuan-select-banlanhdao-dialog
        :isOpen="isOpenSelectBanLanhDaoDialog"
        v-if="isEnableSelectBanLanhDaoDialog"
        :selectedItems="selectedBanLdIds"
        @changed="afterSelectBanLanhDao"
        @closed="isEnableSelectBanLanhDaoDialog = false"
        @closeDialog="isOpenSelectBanLanhDaoDialog = false"
      />

      <mobimeeting-codinh-room-create-dialog
        :isOpen="isOpenCreateRoomDialog"
        :deptId="hcCaseCalendarParentDeptId"
        v-if="isEnableCreateRoomDialog"
        @closed="isEnableCreateRoomDialog = false"
        @closeDialog="isOpenCreateRoomDialog = false"
        @insertSuccess="createRoomSuccess"
      >
      </mobimeeting-codinh-room-create-dialog>
    </template>
  </detailTemplate>
</template>

<script type="text/javascript">
import Vue from "vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import constants from "../../../constants";

import dateUtils from "../../../dateUtils";
import { EventBus } from "../../../event-bus.js";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import attachmentService from "../../../services/attachmentService";

import departmentService from "../../../services/departmentService";
import downloadService from "../../../services/downloadService";

import h from "../../../services/h";
import hanhchinhService from "../../../services/hanhchinhService";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcCaseCalendarService from "../../../services/hcCaseCalendarService";
import hcCaseCalendarUserViewService from "../../../services/hcCaseCalendarUserViewService";
import hcCaseMasterUserService from "../../../services/hcCaseMasterUserService";

import hcCfgMeetingRoomService from "../../../services/hcCfgMeetingRoomService";
import httpService from "../../../services/httpService";
import hcCasePhongHopService from "../../../services/phonghop/hcCasePhongHopService";
import utils from "../../../services/utils";
import uploadFileMixin from "../../doc-in/uploadFileMixin";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import FileTypeImage from "../../job/FileTypeImage";
import MobimeetingCodinhRoomCreateDialog from "../../setting/quanLyPhongHop/mobimeeting-codinh-room-create-dialog";

import HcCaseCalendarPhonghopState from "./hc-case-calendar-phonghop-state";
import HcCaseCalendarSharingDialog from "./hcCaseCalendar-sharing-dialog";
import LichtuanSelectActorsDialog from "./lichtuan-select-actors-dialog";
import LichtuanSelectBanlanhdaoDialog from "./lichtuan-select-banlanhdao-dialog";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import hcCaseCalendarParticipantViewService from "../../../services/hcCaseCalendarParticipantViewService";
import hcCaseCalendarBanLanhDaoService from "../../../services/hcCaseCalendarBanLanhDaoService";

export default {
  name: "LichTuan_Detail",
  mixins: [handleRequestErrorMixin, uploadFileMixin],

  data() {
    return {
      participantsSelectedIds:[],
      sourceListTptd:[],
      listChiefsParticipate:[],
      hcCaseMaster: {},

      TENANT_CODE: constants.TENANT_CODE,
      hcCaseCalendar: {
        services: [],
        otherInvolved2: null,
        criticalLevel: null
      },
      hcCaseCalendarUsers: {},
      hcCoopDepts: [],
      hcChairUnitDepts:[],
      actions: [],
      approve: false,
      decline: false,
      update: false,
      cancel: false,
      selfCancel: false,
      listRooms: [],
      roomIdSelected: null,
      leadersSelected: [],
      selectedBanLdIds: [],
      chairedUnitSelected: [],
      cooperateDeptIds: [],
      chairUnitDeptIds: [],
      cooperateSelectedIds: [],
      chairUnitSelectedIds: [],
      ListchairedUnit: [],
      ListDonViChuTri: [],
      chairedUnit: "",
      vbAttachments: null,
      isCanUpload: false,
      attachmentFiles: [],
      isOpenShareDialog: false,
      isEnableShareDialog: false,

      isOpenSelectActorDialog: false,
      isEnableSelectActorDialog: false,
      isOpenSelectBanLanhDaoDialog: false,
      isEnableSelectBanLanhDaoDialog: false,
      groups: [],
      banLds: [],
      groupFilters: [],
      hcCaseMasterUser: null,
      meetingTypeOptions: [],
      meetingTypeOptions2: [],
      MEETING_TYPE: constants.HC_CASE_CALENDAR.MEETING_TYPE,
      rules: {},
      ableToJoinMeeting: false,
      quyTrinhDepartment: null,
      hcCfgMeetingRooms: null,
      allHcCfgMeetingRooms: null,

      isOpenCreateRoomDialog: false,

      isEnableCreateRoomDialog: false,
      hcCasePhonghop: null,
      criticalLevels: [],
      serviceOptions: [],
      hcCaseCalendar_: null,
      deleteConfirm: false,
      isTptdLoading: false
    };
  },

  components: {
    HcCaseCalendarPhonghopState,
    MobimeetingCodinhRoomCreateDialog,
    LichtuanSelectActorsDialog,
    LichtuanSelectBanlanhdaoDialog,
    HcCaseCalendarSharingDialog,
    FileTypeImage,
    VuePerfectScrollbar,
    detailTemplate: () => import("../../common/detail.vue"),
    Multiselect: () => import("vue-multiselect")
  },

  computed: {
    isRequester() {
      return hanhChinhUtils.isRequester(
        this.userDeptRole,
        this.hcCaseCalendar_
      );
    },

    tenantCode(){
      return this.$store.getters.userDeptRole.tenantCode;
    },

    isVinataba(){
      return this.tenantCode === constants.TENANT_CODE.VINATABA;
    },

    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    uploadAttachmentAdditionalData() {
      return {
        hcCaseCalendarId: this.hcCaseCalendar.id
      };
    },

    uploadAttachmentURL() {
      return constants.BASE_SERVICE_URL + "vbAttachment/uploadHcCalendarFile";
    },

    uploadAttachmentHeaders() {
      return httpService.getUploadAttachmentHeaders();
    },

    caseMasterId() {
      return this.$route.params.id;
    },

    currentDeptId() {
      let userDeptRole = h.find(
        this.$store.state.userDeptRoles,
        userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
      );
      return userDeptRole.deptId;
    },

    parentDeptId() {
      let userDeptRole = h.find(
        this.$store.state.userDeptRoles,
        userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
      );
      return userDeptRole.parentDeptId;
    },

    hcCaseCalendarParentDeptId() {
      return this.hcCaseCalendar ? this.hcCaseCalendar.parentDeptId : null;
    },

    isMeetingOnline() {
      return (
        this.hcCaseCalendar &&
        (this.hcCaseCalendar.meetingType ===
          constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE ||
          this.hcCaseCalendar.meetingType ===

            constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE_MOBIMEETING_CODINH)
      );
    },

    // ableToJoinMeeting() {
    //   return (
    //     this.hcCaseCalendar.status === "HOANTHANH" &&
    //     this.isMeetingOnline &&
    //     this.hcCaseCalendar.hcMeetingRoomId
    //   );
    // },

    id() {
      return this.hcCaseCalendar ? this.hcCaseCalendar.id : null;
    },

    isChoPheDuyet() {
      return this.hcCaseCalendar.approveStatus === constants.HC_CALENDAR.APPROVE_STATUS.CHUA_PHE_DUYET
    },
    isDisplayDeleteButton(){
      let approveStatus = this.hcCaseCalendar.approveStatus
      if (!this.isVinataba
        || approveStatus === constants.HC_CALENDAR.APPROVE_STATUS.CHUA_PHE_DUYET
        || approveStatus === constants.HC_CALENDAR.APPROVE_STATUS.HUY_YEU_CAU
        || this.$store.getters.userDeptRole.roleCode !== constants.ROLE.CODE.TONG_HOP_LICH_TUAN)
        return false
      return true
      // if this.cancel || this.selfCancel || this.isVinataba
      // (cancel || selfCancel || isVinataba) && !isChoPheDuyet
    }
  },

  watch: {
    caseMasterId() {
      this.getAction();
      this.getData()
        .then(() => this.initDisplayLeaders())
        .then(() => this.loadQuyTrinhDepartment())
        .then(() => {
          this.initIsCanUpload();
          this.initAbleToJoinMeeting();
        })
        .then(() => {
          this.initDisplayLeaders();
          this.initBanLanhDao();
        });
    },

    isOpenShareDialog(newValue) {
      newValue && (this.isEnableShareDialog = newValue);
    },

    isOpenSelectActorDialog(newValue) {
      if (newValue) this.isEnableSelectActorDialog = newValue;
    },

    isOpenSelectBanLanhDaoDialog(newValue) {
      if (newValue) this.isEnableSelectBanLanhDaoDialog = newValue;
    },

    isOpenCreateRoomDialog(newValue) {
      if (newValue) this.isEnableCreateRoomDialog = newValue;
    }
  },

  created() {
    this.initMeetingTypeOptions();
    this.initSelectOptions();
    // this.initValidationRules();
    this.getAction();
    this.getData()
      .then(() => this.getListChiefsParticipate(this.hcCaseMaster.id))
      .then(() => this.initSourceListTptd())
      .then(() => {
        this.initDisplayLeaders();
        this.initBanLanhDao();
      })
      .then(() => this.loadQuyTrinhDepartment())
      .then(() => {
        this.initIsCanUpload();
        this.initAbleToJoinMeeting();

      })
      .then(() => this.initMeetingRooms());
  },

  methods: {
    initSourceListTptd() {
      userDeptRoleViewService.findAllByIdIn(this.listChiefsParticipate)
        .then(res => {
          const data = res.data;
          h.each(this.listChiefsParticipate,p => {
            const i = h.indexOf(data, d => d.id === p);
            i > -1 && this.sourceListTptd.push(data[i]);
          })
          // this.sourceListTptd = res.data;
          this.participantsSelectedIds = h.collect(this.sourceListTptd, item => item.id)
        })
    },

    getSourceListTptd(keyword) {
      this.isTptdLoading = true;
      return userDeptRoleViewService
        .getParticipantSourceListForLichTuan(keyword,this.hcCaseMaster.parentDeptId)
        .then(response => {
            this.sourceListTptd = response.data || [];
            this.isTptdLoading = false
          }
        )
    },

    getListChiefsParticipate(id) {
      let res;
      return hcCaseCalendarParticipantViewService
        .findAllChiefsParticipate(id)
        .then(response => {
          res = response.data || [];
          this.listChiefsParticipate = res.map(item => item.userDeptRoleId)
          }
        );
    },

    meetingPlaceChanged() {
      this.hcCaseCalendar.hcCfgMeetingRoomId = null;
    },
    querySearchHcCfgMeetingRoom(queryString, callbackFn) {
      let hcCfgMeetingRooms = h.collect(
        this.hcCfgMeetingRooms,
        hcCfgMeetingRoom => {
          return {
            id: hcCfgMeetingRoom.id,
            roomName: hcCfgMeetingRoom.roomName,
            value: hcCfgMeetingRoom.roomName
          };
        }
      );

      let results = queryString
        ? hcCfgMeetingRooms.filter(
            hcCfgMeetingRoom =>
              hcCfgMeetingRoom.roomName
                .toLowerCase()
                .indexOf(queryString.toLowerCase()) === 0
          )
        : hcCfgMeetingRooms;
      callbackFn(results);
    },

    handleSelectHcCfgMeetingRoom(hcCfgMeetingRoom) {
      this.hcCaseCalendar.hcCfgMeetingRoomId = hcCfgMeetingRoom.id;
      if (!this.hcCaseCalendar.criticalLevel) {
        this.hcCaseCalendar.criticalLevel =
          constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.CO_LANH_DAO;
      }
    },

    loadHcCaseCalendar() {
      return hcCaseCalendarService
        .findByCaseMasterId(this.caseMasterId)
        .then(response => (this.hcCaseCalendar_ = response.data));
    },

    initSelectOptions() {
      this.criticalLevels = hanhChinhUtils.buildPhongHopCriticalLevelOptions();
      this.serviceOptions = hanhChinhUtils.buildPhongHopServiceOptions();
    },

    loadHcCasePhongHop() {
      return (this.hcCaseCalendar_.hcCasePhongHopId
        ? hcCasePhongHopService
            .findById(this.hcCaseCalendar_.hcCasePhongHopId)
            .then(response => response.data)
        : Promise.resolve(null)
      ).then(hcCasePhonghop => {
        if (hcCasePhonghop) {
          this.hcCasePhonghop = hcCasePhonghop;
          Vue.set(
            this.hcCaseCalendar,
            "criticalLevel",
            this.hcCasePhonghop.criticalLevel
          );
          Vue.set(
            this.hcCaseCalendar,
            "otherInvolved2",
            this.hcCasePhonghop.otherInvolved
          );
          Vue.set(
            this.hcCaseCalendar,
            "services",
            (this.hcCasePhonghop.services || "").split(",")
          );
        } else {
          Vue.set(this.hcCaseCalendar, "criticalLevel", null);
          Vue.set(this.hcCaseCalendar, "otherInvolved2", null);
          Vue.set(this.hcCaseCalendar, "services", []);
        }
      });
    },

    initMeetingRooms() {
      this.hcCfgMeetingRooms = h.findAll(
        this.allHcCfgMeetingRooms,
        item =>
          (this.hcCaseCalendar.meetingType ===
            constants.HC_CASE_CALENDAR.MEETING_TYPE.OFFLINE &&
            item.type === constants.HC_CFG_MEETING_ROOM.TYPE.NORMAL) ||
          (this.hcCaseCalendar.meetingType ===
            constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE_MOBIMEETING_CODINH &&
            item.type ===
              constants.HC_CFG_MEETING_ROOM.TYPE.ONLINE_MOBIMEETING_CODINH)
      );
    },

    createRoomSuccess(event) {
      this.isOpenCreateRoomDialog = false;

      return this.loadHcCfgMeetingRooms().then(() => {
        this.hcCaseCalendar.hcCfgMeetingRoomId = event.result.id;
        this.initMeetingRooms();
        return this.hcCaseCalendar.hcCfgMeetingRoomId;
      });
    },

    openAddNewMeetingRoomDialog() {
      this.isOpenCreateRoomDialog = true;
    },

    loadHcCfgMeetingRooms() {
      let deptId = this.hcCaseCalendarParentDeptId;
      return (deptId

        ? hcCfgMeetingRoomService
            .findAll({ deptId: deptId }, { sort: "roomName,asc" })
            .then(response => response.data)

        : Promise.resolve([])
      ).then(
        hcCfgMeetingRooms => (this.allHcCfgMeetingRooms = hcCfgMeetingRooms)
      );
    },

    hcCfgMeetingRoomIdChanged() {
      this.hcCaseCalendar.meetingPlace = this.hcCaseCalendar.hcCfgMeetingRoomId
        ? h.find(

            this.hcCfgMeetingRooms,
            hcCfgMeetingRoom =>
              hcCfgMeetingRoom.id === this.hcCaseCalendar.hcCfgMeetingRoomId
          ).roomName
        : null;
    },

    loadQuyTrinhDepartment() {
      return departmentService
        .findById(this.hcCaseCalendarParentDeptId)
        .then(response => (this.quyTrinhDepartment = response.data));
    },

    initMeetingTypeOptions() {
      let options_ = this.tenantCode === constants.TENANT_CODE.VINATABA
        ? hanhChinhUtils.initMeetingTypeOptionsVinataba() : hanhChinhUtils.initMeetingTypeOptions();
      this.meetingTypeOptions = options_[0];
      this.meetingTypeOptions2 = options_[1];
    },

    meetingTypeChanged() {
      this.hcCaseCalendar.meetingPlace = "";
      this.hcCaseCalendar.hcCfgMeetingRoomId = null;
      this.hcCaseCalendar.criticalLevel = null;
      this.hcCaseCalendar.services = [];
      this.hcCaseCalendar.otherInvolved2 = null;
      // this.initValidationRules();
      this.initMeetingRooms();
    },

    getLabelForFilter(filter) {
      return utils.getLabelForActorGroupFilter(filter);
    },

    initGroupFilters() {
      return (this.hcCaseCalendarParentDeptId === constants.TCT_DEPT_ID
        ? utils.initGroupFilters(actor => {
          return actor.userDeptRoleId;
        })
        :
        (this.hcCaseCalendarParentDeptId === constants.VINATABA_TCT_DEPT_ID
            ? utils.initGroupFiltersVinataba(actor => {
              return actor.userDeptRoleId;
            })
            : Promise.resolve([])
        ))
        .then(groupFilters => {
          this.groupFilters = groupFilters
        });
    },

    //hiển thị gom nhóm danh sách lãnh đạo
    initDisplayLeaders() {
      return Promise.all([
        this.initGroupFilters(),
        this.initLeadersSelected()
      ]).then(() => {
        this.groups = utils.groupActors(
              this.leadersSelected,
              this.groupFilters
        )

      });
    },

    initBanLanhDao() {
      return hcCaseCalendarBanLanhDaoService.findAllByHcCaseCalendarId(this.hcCaseCalendar.id)
        .then(res => {
          this.banLds = h.collect(res.data, item => {
            let label;
            switch (item.banLanhDaoCode) {
              case 'ldtct':
                label = 'Lãnh đạo TCT';
                break;
              case 'hdtv':
                label = 'Hội đồng thành viên';
                break;
              case 'btgd':
                label = 'Ban Tổng giám đốc';
                break;
              default:
                label = '';
            }
            return {
              id: item.banLanhDaoCode,
              label: label
            }
          });

          this.selectedBanLdIds = h.collect(this.banLds, banLd => banLd.id);
        })
    },

    checkLanhDaoVinataba(name){
      if(this.$store.getters.userDeptRole.tenantCode !== constants.TENANT_CODE.VINATABA)
        return true;
      if (name.fullName ===  "Nguyễn Quang Đức" || name.fullName === "Trần Duy Thái" || name.fullName === "ADMINISTRATOR")
        return false;
      else if (name.fullName === "Hà Quang Hòa" && name.deptCode === "HDTV")
        return false;
      return true;
    },

    initLeadersSelected() {
      return hcCaseCalendarUserViewService
        .findAllLanhDaoThamDu(this.caseMasterId)
        .then(response => (this.leadersSelected = response.data));
    },

    afterSelectActors(event) {
      this.isOpenSelectActorDialog = false;
      this.leadersSelected = h.collect(event.userDeptRoles, userDeptRole => {
        return {
          userDeptRoleId: userDeptRole.id,
          userId: userDeptRole.userId,
          fullName: userDeptRole.fullName,
          positionName: userDeptRole.positionName,
          deptName: userDeptRole.deptName
        };
      });
      this.groups = utils.groupActors(this.leadersSelected, this.groupFilters);
    },

    afterSelectBanLanhDao(event) {
      this.isOpenSelectBanLanhDaoDialog = false;
      this.selectedBanLdIds = h.collect(event.selectedData, banLd => banLd.id);
      this.banLds = event.selectedData;
    },

    openSelectActorDialog() {
      this.isOpenSelectActorDialog = true;
    },

    openSelectBanLanhDaoDialog() {
      this.isOpenSelectBanLanhDaoDialog = true;
    },

    sharingSuccess() {
      this.isOpenShareDialog = false;
    },

    share() {
      this.isOpenShareDialog = true;
    },

    joinRoom() {
      return hcCaseCalendarService
        .joinRoom(this.id)
        .then(response => {
          window.open(response.data.urlWeb, "_blank");
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    downloadFile(vbAttachment) {
      downloadService
        .downloadHcCaseCalendarAttachment(
          this.hcCaseCalendar.id,
          vbAttachment.id
        )
        .catch(error => {
          this.notify(
            "Thông báo",
            errorMessageFilter({
              errorCode: "hcLichTuan.canNotDownloadAttachment"
            }),
            "error",
            2000
          );
          throw error;
        });
    },

    /**

       Mở rộng quyền tải file và cập nhật file đính kèm.
       DS người dùng có thể upload file bao gồm: Lãnh đạo
       tham dự, Người tạo yêu cầu, LĐ đơn vị chủ trì, LĐ đơn vị
       phối hợp, vai trò tổng hợp lịch tuần, vai trò đăng ký lịch
       tuần của các đơn vị.


       Danh sách người dùng có quyền xem và tải xuống file đính kèm bao gồm: Lãnh
       đạo tham dự, Người tạo yêu cầu, LĐ đơn vị chủ trì, LĐ đơn vị phối hợp, Tổ giúp
       việc HĐTV, Thư ký Ban TGĐ.


       Người được chia sẻ cũng có thể upload;
       */
    initIsCanUpload() {
      this.isCanUpload =
        this.hcCaseCalendar.requestUserId === this.userDeptRole.userId ||
        this.userDeptRole.roleCode === constants.ROLE.CODE.TONG_HOP_LICH_TUAN ||
        this.userDeptRole.roleCode === constants.ROLE.CODE.DANG_KY_LICH_TUAN ||
        (this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
          && (h.exists(this.cooperateSelectedIds, id => id === this.userDeptRole.deptId)
              || h.exists(this.leadersSelected, item => item.userId === this.userDeptRole.userId))
        ) ||
        (this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
          && (h.exists(this.chairUnitSelectedIds, id => id === this.userDeptRole.deptId)
            || h.exists(this.leadersSelected, item => item.userId === this.userDeptRole.userId))
        )
        || this.hcCaseMasterUser;
    },

    initAbleToJoinMeeting() {
      this.ableToJoinMeeting =
        this.hcCaseCalendar.status === "HOANTHANH" &&
        this.isMeetingOnline &&
        this.hcCaseCalendar.hcMeetingRoomId &&
        (this.isCanUpload ||
          (this.userDeptRole &&
            (this.userDeptRole.userName === "cuong.tm" ||
              this.userDeptRole.userName === "thangnm" ||
              //thu ky ban tgd
              (this.userDeptRole.posCode === constants.POSITION.CODE.THU_KY &&
                this.userDeptRole.deptCode === this.$store.getters.globalRoles) ||
              //to giup viec hoi dong thanh vien
              (this.userDeptRole.roleCode === constants.ROLE.CODE.CHUYEN_VIEN &&
                this.userDeptRole.deptCode === constants.TOGIUPVIEC_HDTV) ||
              this.isLanhDao(this.hcCaseCalendar))));
    },

    /**
     * check là lãnh đạo của quy trình lịch tuần
     * @param hcCaseCalendar
     */
    isLanhDao(hcCaseCalendar) {
      let quyTrinhDeptId = this.hcCaseMaster.parentDeptId;
      departmentService.findById(quyTrinhDeptId).then(response => {
        this.parentDept = response.data;
      });
      return (
        this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO &&
        (this.userDeptRole.deptId === quyTrinhDeptId ||
          //hdtv thi cung la lanhdao cua tct;

          (this.parentDept.deptCode === this.$store.getters.globalRoles &&
            this.userDeptRole.deptCode === constants.HDTV_DEPT_CODE) ||
          //neu la lanh dao cua don vi cha thi cung co quyen xem;
          this.quyTrinhDepartment.path.startsWith(
            this.userDeptRole.deptPath + "/"
          ))
      );
    },

    loadVbAttachments() {
      return attachmentService
        .findAllByHcCalendar(this.caseMasterId)
        .then(response => (this.vbAttachments = response.data));
    },

    removeAttachment(vbAttachment) {
      this.$confirm(
        errorMessageFilter({
          errorCode: "hcLichTuan.deleteAttachment.confirmMessage",
          params: [vbAttachment.fileName]
        }),
        "Thông báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Bỏ qua",
          type: "warning"
        }
      ).then(() => {
        attachmentService
          .deleteHcCalendarFile(vbAttachment.id, this.hcCaseCalendar.id)
          .then(() => this.loadVbAttachments());
      });
    },

    uploadAttachmentSuccess() {
      return this.loadVbAttachments();
    },

    onUploadSuccess(response) {
      this.isUploading = false;
      return new Promise(resolve => resolve(response));
    },

    backListPage() {
      this.$router.push({
        name: "adminstration-regiscalendarweek",
        query: this.$route.query,
        params: this.$route.params
      });
    },

    // lay danh sach lanh dao
    getListLeaders(deptId) {
      hanhchinhService.getListLDLichTuan(deptId).then(response => {
        if (response.data.users) {
          this.leaders = response.data.users;
        }
      });
    },

    //lay danh muc don vi phoi hop, don vi chu tri
    getListDVPHs(deptId) {
      return hanhchinhService.getListDVPH(deptId).then(res => {
        this.ListchairedUnit = res.data.departments;
      });
    },

    getListDVChuTris(deptId) {
      return hanhchinhService.getListDVChuTri(deptId).then(res => {
        this.ListDonViChuTri = res.data.departments;
      });
    },

    // lay danh sach phong hop free
    getListRoomFree() {
      hanhchinhService
        .getListRoomFree(
          this.hcCaseCalendar.startTime,
          this.hcCaseCalendar.endTime
        )
        .then(response => {
          if (response.data.dataRoomFree) {
            this.listRooms = response.data.dataRoomFree;
          }
        });
    },

    loadHcCaseMasterUser() {
      return hcCaseMasterUserService
        .findByHcReferenceId(this.hcCaseCalendar.id)
        .then(response => (this.hcCaseMasterUser = response.data));
    },

    // lay du lieu lich tuan chi tiet
    getData() {
      return hanhchinhService
        .getRegiscalendarweekDetail(this.caseMasterId)
        .then(response => {
          // Lay thong tin chi tiet
          this.hcCaseMaster = response.data.hcCaseMaster;
          this.hcCaseCalendar = response.data.hcCaseCalendar;
          Vue.set(this.hcCaseCalendar, "services", []); //tránh lỗi java-script;
          // this.hcCaseCalendar.services = []; //tránh lỗi java-script;
          this.hcCaseCalendarUsers = response.data.hcCaseCalendarUsers;
          this.hcCoopDepts = response.data.hcCoopDepts;
          this.hcChairUnitDepts = response.data.hcChairUnitDepts;

          // Lay cac danh muc
          // this.getListRoomFree(); // bỏ code này vì k dùng đến giá trị của nó
          this.getListDVPHs(this.hcCaseMaster.parentDeptId)
            .then(() => {
              // Set danh sach don vi phoi hop
              this.cooperateSelectedIds = [];
              if (this.hcCoopDepts.length > 0) {
                let self = this;

                this.hcCoopDepts.forEach(function(coopDept) {
                  self.cooperateSelectedIds.push(coopDept.cooperateDeptId);
                });
              }
            })

          this.getListDVChuTris(this.hcCaseMaster.parentDeptId)
            .then(() => {
              // Set danh sach don vi chu tri
              this.chairUnitSelectedIds = [];
              if(this.hcChairUnitDepts.length > 0){
                let self = this;

                this.hcChairUnitDepts.forEach(function(chairUnitDept) {
                  self.chairUnitSelectedIds.push(chairUnitDept.chairUnitDeptId);
                });
              }
            })
          this.getListLeaders(this.hcCaseMaster.parentDeptId);

          // Set phong hop dc chon
          this.roomIdSelected = null;
          if (this.hcCaseCalendar.isNeedRoom === 1) {
            this.hcCaseCalendar.isNeedRoom = true;
            this.roomIdSelected = this.hcCaseCalendar.roomId;
          }
        })
        .then(() => this.loadHcCaseCalendar())
        .then(() =>
          Promise.all([
            this.loadHcCaseMasterUser(),
            this.loadVbAttachments(),

            this.loadHcCfgMeetingRooms(),
            this.loadHcCasePhongHop()
          ])
        );
    },

    // lay ra quyền thao tác
    getAction() {
      return hanhchinhService.getAction(this.caseMasterId).then(respone => {
        this.actions = respone.data.actions;
        this.approve = false;
        this.decline = false;
        this.update = false;
        this.cancel = false;
        this.selfCancel = false;
        respone.data.actions.forEach(item => {
          if (item.actionCode === "pheduyet") {
            this.approve = true;
          } else if (item.actionCode === "tuchoi") {
            this.decline = true;
          } else if (item.actionCode === "tuhuyyeucau") {
            this.selfCancel = true;
          } else if (item.actionCode === "huyyeucau") {
            this.cancel = true;
          } else if (item.actionCode === "capnhat") {
            this.update = true;
          }
        });
      });
    },

    //thay doi trang thai cua lich tuan

    convertToSubmitForm() {
      return {
        caseMasterId: this.hcCaseCalendar.caseMasterId,
        note: this.hcCaseCalendar.note,
        meetingTitle: this.hcCaseCalendar.meetingTitle,
        meetingContent: this.hcCaseCalendar.meetingContent,
        meetingPlace: this.hcCaseCalendar.meetingPlace,
        meetingType: this.hcCaseCalendar.meetingType,
        startTime: this.hcCaseCalendar.startTime,
        endTime: this.hcCaseCalendar.endTime,
        otherInvolved: this.hcCaseCalendar.otherInvolved,
        // chairedUnit: this.chairedUnitSelected
        //   ? this.chairedUnitSelected.deptName
        //   : null,
        // chairedUnitId: this.chairedUnitSelected
        //   ? this.chairedUnitSelected.id
        //   : null,
        videoConferenceUnit: this.hcCaseCalendar.videoConferenceUnit,
        isNeedRoom: this.hcCaseCalendar.isNeedRoom ? 1 : 0,
        roomId: this.roomIdSelected,
        listUserIds: this.leadersSelected.map(listUser => {
          return listUser.userId;
        }),
        leaders: h.collect(this.leadersSelected, leader => {
          return {
            userId: leader.userId,
            userDeptRoleId: leader.userDeptRoleId
          };
        }),
        cooperateDeptIds: this.cooperateSelectedIds,
        chairUnitDeptIds: this.chairUnitSelectedIds,

        hcCfgMeetingRoomId: this.hcCaseCalendar.hcCfgMeetingRoomId,
        hcCasePhongHopForm: {
          otherInvolved: this.hcCaseCalendar.otherInvolved2,
          criticalLevel: this.hcCaseCalendar.criticalLevel,
          services: this.hcCaseCalendar.services
        },
        others: this.hcCaseCalendar.others,
        noteText:this.hcCaseCalendar.noteText,
        participants : h.collect(this.participantsSelectedIds, id => ({
          userId: null,
          userDeptRoleId: id
        })),
        banLdIds: this.selectedBanLdIds
      };
    },

    validateDuplicateRoom_(status) {
      let params = {
        excludeId: this.id,
        hcCfgMeetingRoomId: this.hcCaseCalendar.hcCfgMeetingRoomId,
        startTime: dateUtils
          .toMoment(this.hcCaseCalendar.startTime)
          .toDate()
          .getTime(),
        endTime: dateUtils
          .toMoment(this.hcCaseCalendar.endTime)
          .toDate()
          .getTime(),
        status: status
      };

      if (!params.hcCfgMeetingRoomId || !params.startTime || !params.endTime)
        return Promise.resolve([]);

      return hcCaseCalendarService
        .findAllWhichUsedRoom(params)
        .then(response => response.data);
    },

    validateDuplicateRoomWithConfirm(status) {
      return new Promise(resolve => {
        this.validateDuplicateRoom_(status).then(duplicatedHcCaseCalendars => {
          if (!duplicatedHcCaseCalendars || !duplicatedHcCaseCalendars.length) {
            resolve();
          } else {
            let duplicatedHcCaseCalendar = duplicatedHcCaseCalendars[0];
            let confirmMsg = errorMessageFilter({
              errorCode: "hcCaseCalendar.duplidatedRoom.confirm",
              params: [
                hanhChinhUtils.buildHcCaseCalendarInfo(duplicatedHcCaseCalendar)
              ]
            });
            this.$confirm(confirmMsg, "Thông báo", {
              confirmButtonText: "Đồng ý",
              cancelButtonText: "Hủy",
              type: "warning"
            }).then(() => resolve());
          }
        });
      });
    },

    confirmDuplicateRoom(status) {
      return new Promise(resolve => {
        this.validateDuplicateRoom_(status)
          .then(duplicatedHcCaseCalendars => {
            if (!duplicatedHcCaseCalendars || !duplicatedHcCaseCalendars.length) {
              resolve();
            } else {
              let duplicatedHcCaseCalendar = duplicatedHcCaseCalendars[0];
              let confirmMsg = errorMessageFilter({
                errorCode: "hcCaseCalendar.duplidatedRoom.confirm",
                params: [
                  hanhChinhUtils.buildHcCaseCalendarInfo(duplicatedHcCaseCalendar)
                ]
              });
              return this.$confirm(confirmMsg, "Thông báo", {
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Hủy",
                type: "warning"
              }).then(() => resolve())
                .catch(() => {});
            }
        });
      });
    },

    confirmDuplicateTime() {
      const form = {
        caseMasterId: this.hcCaseCalendar.caseMasterId,
        listUserIds: this.leadersSelected.map(listUser => {
          return listUser.userId;
        }),
        startTime: dateUtils.toMoment(this.hcCaseCalendar.startTime).toDate().getTime(),
        endTime: dateUtils.toMoment(this.hcCaseCalendar.endTime).toDate().getTime()
      };
      return hanhchinhService.checkDuplicateTime(form)
        .then(res => {
          if (res.data.length > 0) {
            const lds = res.data.join(', ');

            const ce = this.$createElement;
            return this.$msgbox({
              title: 'Thông báo',
              type: 'warning',
              message: ce('div', null, [
                ce('p', null, `Đã có lịch làm việc của lãnh đạo ${lds} trong thời gian này.`),
                ce('p', null, 'Bạn có chắc muốn tiếp tục?')
              ]),
              showCancelButton: true,
              confirmButtonText: 'Đồng ý',
              cancelButtonText: 'Hủy'
            });
          }
        });
    },

    changeCalendarStatus() {
      return this.validateForm()
        .then(() => {
          let submitForm = this.convertToSubmitForm();

          return (this.hcCaseCalendar.meetingType ===
            constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE_MOBIMEETING_CODINH
              ? this.validateDuplicateRoomWithConfirm([
                constants.CASE_MASTER_STATUS.HOAN_THANH,
                constants.CASE_MASTER_STATUS.DANG_XU_LY
              ])
              : Promise.resolve()
          ).then(() => {
            hanhchinhService
              .changeCalendarStatus(submitForm)
              .then(() => {
                this.notifySuccess("Tạm duyệt lịch tuần thành công");
                EventBus.$emit("eventCalled", {});
                this.backListPage();
              })
              .catch(error => {
                this.commonHandleRequestError(error);
                throw error;
              });
          });
        });
    },

    // Phe duyet lich tuan
    approveRequest() {
      return this.validateForm()
        .then(() => this.confirmDuplicateRoom([constants.CASE_MASTER_STATUS.HOAN_THANH]))
        .then(() => this.confirmDuplicateTime())
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          submitForm.action = "pheduyet";

          this.$confirm("Bạn chắc chắn muốn ban hành yêu cầu này không?", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy bỏ",
            type: "warning"
          }).then(() => {
            hanhchinhService
              .approveCalendarWeek(submitForm)
              .then(() => {
                this.notifySuccess("Đã ban hành yêu cầu thành công !");
                EventBus.$emit("eventCalled", {});
                this.backListPage();
              })
              .catch(error => {
                this.commonHandleRequestError(error);
                throw error;
              });
          });
        })
        .catch(() => console.log('Cancel'))
    },

    // Tu choi phe duyet lich tuan
    declineRequest() {
      if (!this.hcCaseCalendar.note) {
        return this.notifyError("Vui lòng nhập lý do từ chối yêu cầu");
      }
      if (this.hcCaseCalendar.note.length > 100) {
        return this.notifyError(
          "Lý do vượt quá 100 kí tự. Vui lòng kiểm tra lại."
        );
      }

      return this.validateForm()
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          submitForm.action = "tuchoi";

          this.$confirm("Bạn chắc chắn muốn từ chối yêu cầu này ?", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy bỏ",
            type: "warning"
          }).then(() => {
            hanhchinhService
              .approveCalendarWeek(submitForm)
              .then(() => {
                this.notifySuccess("Đã từ chối yêu cầu !");
                EventBus.$emit("eventCalled", {});
                this.backListPage();
              })
              .catch(error => {
                this.commonHandleRequestError(error);
                throw error;
              });
          });
        });
    },

    //validate
    validateForm() {
      return new Promise(resolve => {
        if (this.tenantCode !== constants.TENANT_CODE.VINATABA && !this.hcCaseCalendar.meetingTitle) {
          this.notifyError("Vui lòng nhập tiêu đề");
          this.$refs.title.focus();
          return true;
        }

        if (this.hcCaseCalendar.meetingTitle && this.hcCaseCalendar.meetingTitle.length > 200) {
          this.notifyError(
            "Tiêu đề vượt quá 200 kí tự. Vui lòng kiểm tra lại !"
          );
          this.$refs.title.focus();
          return true;
        }

        if (this.hcCaseCalendar.meetingContent && this.hcCaseCalendar.meetingContent.length > 400) {
          this.notifyError(
            "Nội dung công việc vượt quá 400 kí tự. Vui lòng kiểm tra lại !"
          );
          return true;
        }

        if (!this.hcCaseCalendar.startTime) {
          this.notifyError("Vui lòng chọn thời gian bắt đầu");
          return true;
        }

        if (!this.hcCaseCalendar.endTime) {
          this.notifyError("Vui lòng chọn thời gian kết thúc");
          return true;
        }

        if (new Date(this.hcCaseCalendar.endTime) < new Date(this.hcCaseCalendar.startTime)) {
          this.notifyError("Thời gian kết thúc trước thời gian bắt đầu");
          return true;
        }

        if (!this.hcCaseCalendar.meetingType) {
          this.notifyError("Vui lòng chọn loại cuộc họp");
          return true;
        }

        if (
          this.hcCaseCalendar.meetingType === constants.HC_CASE_CALENDAR.MEETING_TYPE.OFFLINE
        ) {
          if (!this.hcCaseCalendar.meetingPlace) {
            this.notifyError("Vui lòng nhập địa điểm");
            this.$refs.meetingPlace.focus();
            return true;
          }

          if (this.hcCaseCalendar.meetingPlace && this.hcCaseCalendar.meetingPlace.length > 200) {
            this.notifyError(
              "Địa điểm vượt quá 200 kí tự. Vui lòng kiểm tra lại !"
            );
            return true;
          }
        }

        if (
          this.hcCaseCalendar.meetingType ===

            constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE_MOBIMEETING_CODINH &&
          !this.hcCaseCalendar.hcCfgMeetingRoomId
        ) {
          this.notifyError("Trường Phòng họp bắt buộc nhập");
          return true;
        }

        if (
          this.hcCaseCalendar.otherInvolved &&
          this.hcCaseCalendar.otherInvolved.length > 500
        ) {
          this.notifyError(
            "Ghi chú vượt quá 500 kí tự. Vui lòng kiểm tra lại !"
          );
          return true;
        }

        if (
          this.hcCaseCalendar.videoConferenceUnit &&
          this.hcCaseCalendar.videoConferenceUnit.length > 500
        ) {
          this.notifyError(
            "Đơn vị họp qua cầu truyền hình vượt quá 500 kí tự. Vui lòng kiểm tra lại !"
          );
          return true;
        }

        // if (this.leadersSelected.length <= 0) {
        //   this.notifyError("Vui lòng chọn danh sách lãnh đạo");
        //   return true;
        // }

        if (this.hcCaseCalendar.isNeedRoom && this.roomIdSelected === null) {
          this.notifyError("Vui lòng chọn phòng họp");
          return true;
        }

        resolve();
      });
    },

    // Cap nhap yc lich tuan
    beforeUpdateRequest() {
      return this.validateForm()
        .then(() => this.confirmDuplicateRoom([constants.CASE_MASTER_STATUS.HOAN_THANH]))
        .then(() => this.confirmDuplicateTime())
        .then(() => this.updateRequest())
        .catch(() => console.log("Update fail!!!"))
    },

    // Cap nhap yc lich tuan
    updateRequest() {
      this.roomIdSelected = this.hcCaseCalendar.isNeedRoom
        ? this.roomIdSelected
        : null;
      let submitForm = this.convertToSubmitForm();

      hanhchinhService
        .updateCalendarWeek(submitForm)
        .then(() => {
          this.notifySuccess("Cập nhập yêu cầu thành công !");
          EventBus.$emit("eventCalled", {});
          this.backListPage();
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    // Huy YCLT
    cancelRequest() {
      if (!this.hcCaseCalendar.note) {
        return this.notifyError("Vui lòng nhập lý do hủy yêu cầu");
      }

      if (this.hcCaseCalendar.note.length > 400) {
        return this.notifyError(
          "Lý do vượt quá 400 kí tự. Vui lòng kiểm tra lại."
        );
      }

      let submitForm = {
        action: this.selfCancel === true ? "tuhuyyeucau" : "huyyeucau",
        caseMasterId: this.hcCaseCalendar.caseMasterId,
        note: this.hcCaseCalendar.note
      };

      let titleComfirm =
        this.selfCancel === true
          ? "Bạn có chắc chắn muốn tự hủy yêu cầu này ?"
          : "Bạn có chắc chắn muốn hủy yêu cầu này ?";

      this.$confirm(titleComfirm, {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        hanhchinhService
          .cancelCalendarWeek(submitForm)
          .then(() => {
            this.notifySuccess("Hủy yêu cầu thành công !");
            EventBus.$emit("eventCalled", {});
            this.backListPage();
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
      });
    },

    deleteRequest(){
      let submitForm = {
        action:  "xoayeucau",
        caseMasterId: this.hcCaseCalendar.caseMasterId,
        note: (this.hcCaseCalendar.note != null) ? this.hcCaseCalendar.note : ""
      };

      let titleComfirm = "Bạn có chắc chắn muốn xóa yêu cầu này ?";

      this.$confirm(titleComfirm, {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        hanhchinhService
          .deleteCalendarWeek(submitForm)
          .then(() => {
            this.notifySuccess("Xóa yêu cầu thành công !");
            EventBus.$emit("eventCalled", {});
            this.backListPage();
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
      });
    },

    notifyError(msg) {
      this.notify("Lỗi", msg, "error", 2000);
    },
    notifySuccess(msg) {
      this.notify("Thông báo", msg, "success", 2000);
    },

    buildUserDeptRoleViewLabel(item) {
      return `${item.fullName} (${item.positionName} - ${item.deptName})`
    }
  }
};
</script>
<style type="text/css" scoped>
.myClass {
  opacity: 1 !important;
}

a.select-link {
  color: #adadad;
  text-decoration: none;
  cursor: pointer;
}

a.select-link:hover {
  color: #adadad;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/LichTuan_Detail.vue